import { loadSettings } from './utils/loadSettings.js';
const getHermesSettings = async ({ type, stage, langTenantUrl }) => {
    const settingsStage = (stage === 'localhost' ? 'development' : stage.toLowerCase());
    const settingsFile = await loadSettings(settingsStage, type);
    const langTenant = langTenantUrl.split('-');
    const tenantUrl = langTenant.length === 2 ? langTenant[1] : langTenant[0];
    const tenantUrlName = settingsFile.MAPPING?.[tenantUrl];
    const settings = settingsFile.TENANTS?.[`hermes-${tenantUrlName}`] || settingsFile.TENANTS['hermes-uk'];
    if (type === 'tenant') {
        return {
            name: settings.NAME,
            locales: settings.LOCALES,
            languages: settings.languages || settings.LOCALES,
            timezone: settings.TIMEZONE,
            contactPhoneNumber: settings.CONTACT_PHONE_NUMBER,
            showBanner: settings.SHOW_BANNER,
            searchWidgetShowSpecialists: settings.SEARCH_WIDGET_SHOW_SPECIALISTS,
            defaultCurrency: settings.DEFAULT_CURRENCY,
            gmcRegistrationBodyId: settings.GMC_REGISTRATION_BODY_ID,
            skipUrlLanguage: settings.SKIP_URL_LANGUAGE,
            defaultSearch: {
                lat: settings.SEARCH?.DEFAULT_SEARCH_LAT,
                lon: settings.SEARCH?.DEFAULT_SEARCH_LON
            },
            footerColumnLinks: settings.FOOTER_COLUMN_LINKS,
            footerSocialLinks: settings.FOOTER_SOCIAL_LINKS,
            defaultGooglePlaceId: settings.DEFAULT_GOOGLE_PLACE_ID,
            defaultLocations: settings.DEFAULT_LOCATIONS,
            gtmKey: settings.GTM_KEY,
            searchDistanceUnits: settings.SEARCH?.SEARCH_DISTANCE_UNITS,
            searchDistanceDefaultValue: settings.SEARCH?.SEARCH_DISTANCE_DEFAULT_VALUE,
            search: settings.SEARCH,
            dashboardUrl: settings.DASHBOARD_URL
        };
    }
    return settings;
};
export { getHermesSettings };
//# sourceMappingURL=index.js.map